<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .c-header
  {
    background-color: #004043;
  }
  .c-header-nav-link
  {
    color: #fff !important;
  }
  .c-subheader
  {
    display: none;
  }
  .c-sidebar-brand > svg
  {
    display: none !important;
  }
.c-sidebar {
    color: #fff;
    background: #004043;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Global classes */
.disabled > input,
.disabled > .dropdown
{
  pointer-events: none;
  opacity: 0.7;
  user-select: none;
}
.disabled {
  pointer-events: none;
  opacity: 0.7;
  user-select: none;
}
// border css for vue-editor and vue-tags-input
.vue-tags-input.is-invalid .ti-input,
.quillWrapper.is-invalid .ql-toolbar.ql-snow,
.quillWrapper.is-invalid #quill-container
{
  border-color: red;
}
</style>
